import { render, staticRenderFns } from "./ProfilingResult.vue?vue&type=template&id=4dce382d&scoped=true"
import script from "./ProfilingResult.vue?vue&type=script&lang=js"
export * from "./ProfilingResult.vue?vue&type=script&lang=js"
import style0 from "./ProfilingResult.vue?vue&type=style&index=0&id=4dce382d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce382d",
  null
  
)

export default component.exports